<template>
  <el-dialog :visible.sync="show"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
             width="350px"
             top="30vh">
    <div class="confirm-container">
      <div class="confirm-tip">
        <span :class="type">!</span>{{ languages.applyConfirm.confirm }}
      </div>
      <div class="confirm-item">
        <div class="confirm-title">{{ languages.applyConfirm.softname }}:</div>
        <div class="confirm-desc">{{ software.softwareName }}</div>
      </div>
      <div class="confirm-item">
        <div class="confirm-title">{{ languages.applyConfirm.dstname }}:</div>
        <div class="confirm-desc">{{ software.pcName }}</div>
      </div>
      <div class="confirm-item">
        <div class="confirm-title">{{ languages.applyConfirm.username }}:</div>
        <div class="confirm-desc">{{ software.username }}</div>
      </div>
      <div class="reason-container">
        <el-input size="small"
                  :placeholder="languages.softInstall.applyReason"
                  clearable
                  v-model="applyReason"></el-input>
      </div>
      <div class="soft-cost">{{languages.applyConfirm.costTip}}: {{software.cost}}</div>
    </div>

    <span slot="footer"
          class="dialog-footer">
      <el-button class="button-cancel"
                 @click="Cancel">{{ languages.cancel }}</el-button>
      <el-button class="button-confirm"
                 type="primary"
                 :loading="submitting"
                 @click="Submit">{{
        languages.confirm
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      applyReason: '',
    };
  },
  props: {
    languages: Object,
    type: String,
    show: Boolean,
    software: Object,
    reason: String,
    submitting: Boolean,
  },
  methods: {
    Cancel () {
      this.$parent.cancelApply();
    },
    Submit () {
      if (this.applyReason.trim() === '') {
        this.$message.warning(this.languages.softInstall.applyReason);
      } else {
        this.$parent.submitApply(this.applyReason);
        this.applyReason = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.reason-container {
  display: flex;
  margin: 10px 20px 5px 45px;
}
.soft-cost {
  margin-left: 45px;
  font-size: 12px;
}
</style>
